<script>
  import GanttHelper from './GanttHelper.js';

  export let GanttStore;

  export let Timestamps;
  export let Color;
  export let StartYMain;
  export let HeightYMain;
  export let StartYSub;
  export let HeightYSub;
  export let StartDate;
  export let EndDate;
  export let AdjustStamp;
  export let DisplayRatio = 1;

  // Optimization parameters
  export let HiddenBarBorders;
  export let SimplifiedShape;

  const {
    CurrentDisplayedEndDateInclDaysOff,
    GetAdjustedDateInclDaysOff,
  } = GanttStore;

  const CalculateStampX = (stamp) => Math.max(0, Math.min(100, 100 * GanttHelper._gantHelper_scale($GetAdjustedDateInclDaysOff(AdjustStamp(stamp)).getTime(), EndDate.getTime(), StartDate.getTime())));
  const CalculateStampXDifferential = (stamp1, stamp2) => CalculateStampX(stamp2) - CalculateStampX(stamp1);
  const DarkenColor = (color) => GanttHelper._gantHelper_darkenColor(GanttHelper._gantHelper_rgbToHex(color), 30);

  const CalculateStampXDisplayRatioBalanced = (stamps, displayRatio) => {
    function _getInterval(K, D) {
        let totalRange = 0;
        for (let i = 0; i < K.length; i += 2) {
            totalRange += K[i + 1] - K[i];
        }

        let targetValue = D * totalRange;

        let cumulativeRange = 0;
        for (let i = 0; i < K.length; i += 2) {
            let intervalStart = K[i];
            let intervalEnd = K[i + 1];
            let intervalRange = intervalEnd - intervalStart;

            if (targetValue <= cumulativeRange + intervalRange) {
                let intervalPercentage = (targetValue - cumulativeRange) / intervalRange;
                const input = intervalStart + intervalPercentage * intervalRange;
                return (input - K[0]) / (K[K.length - 1] - K[0])
            }

            cumulativeRange += intervalRange;
        }
        return 1;
    }

    const _actualRatio = _getInterval(stamps.map((e) => e.getTime()), displayRatio);
    const _diff = (stamps[stamps.length - 1].getTime() - stamps[0].getTime()) * _actualRatio;
    const _endDate = new Date(stamps[0].getTime() + _diff);
    return CalculateStampXDifferential(stamps[0], _endDate);
  }

</script>

{#if SimplifiedShape === true}
  <rect
    x="{CalculateStampX(Timestamps[0])}%"
    y="{StartYMain}%"
    height="{HeightYMain}%"
    width="{CalculateStampXDisplayRatioBalanced(Timestamps, DisplayRatio)}%"
    fill={Color}
    stroke={(HiddenBarBorders === true) ? "none" : DarkenColor(Color)}
    stroke-width={(HiddenBarBorders === true) ? 0 : 1}
  />

{:else}
  <rect
    x="{CalculateStampX(Timestamps[0])}%"
    y="{StartYSub}%"
    height="{HeightYSub}%"
    width="{CalculateStampXDifferential(Timestamps[0],Timestamps[Timestamps.length-1])}%"
    fill={Color}
    stroke={(HiddenBarBorders === true) ? "none" : DarkenColor(Color)}
    stroke-width={(HiddenBarBorders === true) ? 0 : 1}
  />
  {#each Timestamps as timestamp, index}
    {#if index % 2 === 0}
      <rect
        x="{CalculateStampX(Timestamps[index])}%"
        y="{StartYMain}%"
        height="{HeightYMain}%"
        width="{CalculateStampXDifferential(Timestamps[index],Timestamps[index+1])}%"
        fill={Color}
        stroke={(HiddenBarBorders === true) ? "none" : DarkenColor(Color)}
        stroke-width={(HiddenBarBorders === true) ? 0 : 1}
      />
    {/if}
  {/each}

  {#if HiddenBarBorders === false}
    <rect
      x="{CalculateStampX(Timestamps[0])}%"
      y="{StartYSub}%"
      height="{HeightYSub}%"
      width="{CalculateStampXDifferential(Timestamps[0],Timestamps[Timestamps.length-1])}%"
      fill={Color}
    />
  {/if}
{/if}

<style>
</style>
